import axios from 'axios'

export async function loadConfig() {
  const response = await axios.get((process.env.BASE_API || '/api') + '/navigation/public/config', { timeout: 15000 })
  if (!response.data || response.data.code !== 200) throw new Error('页面配置加载失败')
  return response.data.data || {}
}
export function safeLink(value) {
  try { const url = new URL(value); return /^https?:$/.test(url.protocol) && !url.username && !url.password ? url.href : '' } catch (_) { return '' }
}
export function safeImage(value) {
  return /^\/upload\/customer\/[0-9]{8}\/[a-f0-9]+\.(jpg|jpeg|png|gif|webp)$/i.test(value || '') ? value : ''
}



// WEBPACK FOOTER //
// ./src/api.js